import { render, staticRenderFns } from "./mulAlarmInfo.vue?vue&type=template&id=5c9e73d6&scoped=true"
import script from "./mulAlarmInfo.vue?vue&type=script&lang=js"
export * from "./mulAlarmInfo.vue?vue&type=script&lang=js"
import style0 from "./mulAlarmInfo.vue?vue&type=style&index=0&id=5c9e73d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9e73d6",
  null
  
)

export default component.exports